import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentCard } from 'components/ContentCard';
import { WellbeingTypes } from 'constants/wellbeing';
import { useWellbeingContent } from 'hooks/useWellbeingContent';
import { DEFAULT_CATEGORY } from 'pages/WellBeingContent/types';
import type { Wellbeing } from 'types/wellbeing';
import { CategoryFilter } from '../CategoryFilter';

export const PastTrainingsSection = (): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.WELL_BEING);
  const [showPastTrainings, setShowPastTrainings] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(DEFAULT_CATEGORY);

  const { data: trainingsList } = useWellbeingContent(WellbeingTypes.trainings);
  const recordedTrainings: Wellbeing[] = trainingsList?.filter(item => item.videoURL) ?? [];

  const filteredTrainings =
    selectedCategory === DEFAULT_CATEGORY
      ? recordedTrainings
      : recordedTrainings.filter(item => item.tags.some(tag => tag === selectedCategory));
  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-center">
        <Button
          variant="terciary"
          className="w-fit"
          onClick={() => setShowPastTrainings(prev => !prev)}
        >
          {showPastTrainings
            ? t(`TrainingCalendar.hidePrevious.cta`)
            : t(`TrainingCalendar.viewPrevious.cta`)}
        </Button>
      </div>
      {showPastTrainings && (
        <>
          <CategoryFilter
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            content={recordedTrainings}
          />
          <div className="bg-white rounded-lg shadow-sm border p-4 am-sm:p-5 am-md:p-6 am-lg:p-8">
            <div className="grid grid-cols-1 am-lg:grid-cols-2 am-2xl:grid-cols-3 am-3xl:grid-cols-4 gap-3 am-sm:gap-4 am-lg:gap-5 w-full min-w-0 justify-items-center">
              {filteredTrainings.map(item => (
                <div
                  key={item.id ?? item.title}
                  className="min-w-0 w-full max-w-full flex justify-center"
                >
                  <ContentCard {...item} />
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
